export default "__VITE_ASSET__DVjv9nzq__"